exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-select[data-v-739b591b] {\n    background-color: #fff;\n}\n.filter-select.open[data-v-739b591b] .selected-tag {\n    margin-top: 3px;\n}\n.filter-select[data-v-739b591b] .dropdown-toggle {\n    border: 1px solid #c6c6c6;\n    max-height: 31px;\n    margin-top: -1px;\n    padding: 1px 0 3px 0;\n}\n.filter-select[data-v-739b591b] .selected-tag {\n    margin: 3px 0 0 0;\n    padding-left: 5px;\n    white-space: nowrap;\n    overflow: hidden;\n    width: 200px;\n}\n.filter-select[data-v-739b591b] .vs__actions button {\n    margin-top: 3px;\n}\n", ""]);

// exports
